import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Clock, LogOut, Building2, Store } from 'lucide-react';

export default function WorkspacePendingPage() {
  const { user, logout, workspaceName, workspaceType } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4" data-testid="workspace-pending-page">
      <div className="w-full max-w-md text-center space-y-6">
        <div className="flex justify-center">
          <div className="w-16 h-16 rounded-2xl bg-amber-100 dark:bg-amber-900/40 flex items-center justify-center">
            <Clock className="w-8 h-8 text-amber-600 dark:text-amber-400" />
          </div>
        </div>

        <div>
          <h1 className="text-2xl font-bold tracking-tight" data-testid="pending-title">Pending Approval</h1>
          <p className="text-muted-foreground mt-2 text-sm">
            Your account is being reviewed by the platform team.
          </p>
        </div>

        <Card className="border border-amber-200 dark:border-amber-800/50 bg-amber-50/50 dark:bg-amber-950/20">
          <CardContent className="p-5 space-y-3">
            <div className="flex items-center justify-center gap-2">
              {workspaceType === 'company'
                ? <Building2 className="w-5 h-5 text-blue-500" />
                : <Store className="w-5 h-5 text-emerald-500" />
              }
              <span className="font-semibold">{workspaceName || 'Your Account'}</span>
            </div>
            <div className="flex items-center justify-center gap-2 text-xs text-muted-foreground">
              <div className="w-2 h-2 rounded-full bg-amber-500 animate-pulse" />
              Pending review
            </div>
            <p className="text-xs text-muted-foreground">
              You'll get full access once your account is approved.
              This usually takes a short while.
            </p>
          </CardContent>
        </Card>

        <div className="space-y-2">
          <Button variant="outline" size="sm" onClick={() => window.location.reload()} data-testid="pending-refresh-btn">
            Check Again
          </Button>
          <div>
            <Button variant="ghost" size="sm" onClick={logout} className="text-muted-foreground" data-testid="pending-logout-btn">
              <LogOut className="w-3.5 h-3.5 mr-1.5" /> Sign Out
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
